import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { RootStoreState } from '@app/root-store';
import { VaultStoreEffects } from '@app/root-store/vault-store/effects';
import { DocumentService } from '@app/shared/services';
import { select, Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import * as loginSelectors from '../../../root-store/login-store/login.selector';
import * as selectors from '../../../root-store/relationship-store/relationship.selector';

import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
@AutoUnsubscribe()
@Component({
  selector: 'checklist-owner-list',
  templateUrl: './checklist-owner-list.component.html',
  styleUrl: './checklist-owner-list.component.scss',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChecklistOwnerListComponent implements OnInit, OnDestroy {
  @Input() currentFormId: any;
  @Input() loginOwnerUserProfile: any;
  @Input() isAlreadyGrant: boolean;

  @Output() close = new EventEmitter<any>();

  selectedOption = 'Last Added';
  @ViewChild('search') searchElement: ElementRef;
  filterString = '';
  connectedUserinPolicy = false;
  currentDate;
  getAllClientGroups$;
  clientGroups = [];
  datas = [];
  user;
  impersonateUserIdForReport = false;
  searchString: FormControl;
  subscription = new Subscription();
  text = 'reminder';
  ownerUserProfile = {
    id: '',
    name: '',
    image: '',
  };
  currentFormIdList = [];
  vaultStateObject;
  entitiesItems;
  searchedStr: string;
  policy: any = '';
  members: any = '';
  selectedUserIndex: number = -1; // Add this variable to your component class

  constructor(
    private store$: Store<RootStoreState.State>,
    private store: Store,
    private cd: ChangeDetectorRef,
    private documentService: DocumentService,
    private vaultService: VaultStoreEffects
  ) {
    this.subscription.add(
      this.store.pipe(select(loginSelectors.getCurrentUserFullDetails)).subscribe((result) => {
        if (result) {
          this.user = result;
        } else {
          this.user = null;
        }
      })
    );
    this.subscription.add(
      this.vaultService.vaultObject.subscribe((state) => {
        this.vaultStateObject = state;
      })
    );
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.searchElement.nativeElement.focus();
    }, 0);
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  grantPermission(item, i) {
    let currentfomtList = this.currentFormIdList.length > 0 ? this.currentFormIdList : [this.currentFormId];
    const request = {
      formids: currentfomtList,
      user_id: item.user_id,
    };
    this.subscription.add(
      this.documentService.grantPermission(request).subscribe((res) => {
        if (res) {
          const data = { id: item.user_id, name: item.user_first_middle_name + ' ' + item.user_last_name, image: item.user_profile_image_url };
          this.close.emit({
            isSuccess: true,
            item: data,
          });
        }
      })
    );
  }

  openFolder(item, i) {
    if (item.user_id == this.loginOwnerUserProfile.id) return;
    if (this.isAlreadyGrant) {
      const data = { id: item.user_id, name: item.user_first_middle_name + ' ' + item.user_last_name, image: item.user_profile_image_url };
      this.close.emit({
        isSuccess: true,
        item: data,
      });
      return;
    }
    if (this.selectedUserIndex !== i) {
      // Reset the access for all users except the current one
      this.clientGroups.forEach((group, index) => {
        if (index !== i) {
          group.isAccess = false; // Close the previous permission message
        }
      });
      this.selectedUserIndex = i; // Set the new selected index
    }
    this.clientGroups[i].isRunning = true;
    this.cd.detectChanges();
    let currentfomtList = this.currentFormIdList.length > 0 ? this.currentFormIdList : [this.currentFormId];
    this.subscription.add(
      this.documentService.checkUserHasFormAccess(item.user_id, currentfomtList).subscribe((res) => {
        this.clientGroups[i].isRunning = false;
        this.clientGroups[i].isAccess = res.access;
        if (res.access) {
          const data = { id: item.user_id, name: item.user_first_middle_name + ' ' + item.user_last_name, image: item.user_profile_image_url };
          this.close.emit({
            isSuccess: true,
            item: data,
          });
        }
        this.cd.detectChanges();
      })
    );
  }

  addLoginUser() {
    // if (this.ownerUserProfile?.id == this.loginOwnerUserProfile.id) return;
    const data = { id: this.ownerUserProfile.id, name: this.ownerUserProfile.name, image: this.ownerUserProfile.image };
    this.close.emit({
      isSuccess: true,
      item: data,
    });
  }

  ngOnInit(): void {
    this.currentFormId = this.currentFormId;

    if (this.text === 'task') {
      this.text = 'task';
    }
    if (this.currentFormIdList) {
      this.text = 'task(s)';
      this.currentFormIdList = this.currentFormIdList;
    }
    this.ownerUserProfile = this.loginOwnerUserProfile;

    if (this.impersonateUserIdForReport) {
      this.impersonateUserIdForReport = true;
    }
    if (this.text !== 'entity') this.getFilterData();
    if (this.text === 'entity') this.getFormUserFormAssociation();
    this.searchString = new FormControl();
    this.subscription.add(
      this.searchString.valueChanges.subscribe((res) => {
        this.filterString = res;

        this.datas.push(this.ownerUserProfile);
        if (this.text !== 'entity') this.getFilterData();
        if (this.text === 'entity') this.getFormUserFormAssociation();
      })
    );
  }

  getFilterData() {
    if (this.policy) {
      this.connectedUserinPolicy = this.members.some((obj) => obj.userid === this.ownerUserProfile.id);
      this.subscription.add(
        this.store$.pipe(select(selectors.getAndFilterAllUsers(this.filterString))).subscribe((res) => {
          const newArr = res
            .filter((item) => {
              return this.members.every((filterItem) => filterItem.userid != item.user_id);
            })
            .map((element) => ({
              ...element,
              isAccess: true,
              connection_status: 'approved',
            }));
          this.clientGroups = newArr;
          this.cd.detectChanges();
        })
      );
    } else {
      if (this.impersonateUserIdForReport) {
        this.subscription.add(
          this.store$.pipe(select(selectors.getAndFilterAllImpersonatesUsers(this.filterString))).subscribe((res) => {
            const newArr = res.map((element) => ({
              ...element,
              isRunning: false,
              isAccess: true,
            }));
            this.clientGroups = newArr;
            this.cd.detectChanges();
          })
        );
      } else {
        this.subscription.add(
          this.store$.pipe(select(selectors.getAndFilterAllUsers(this.filterString))).subscribe((res) => {
            const newArr = res.map((element) => ({
              ...element,
              isRunning: false,
              isAccess: true,
            }));
            this.clientGroups = newArr;
            this.cd.detectChanges();
          })
        );
      }
    }
  }

  getFormUserFormAssociation() {
    this.subscription.add(
      this.documentService.getFormUserFormAssociation(this.vaultStateObject?.userId, this.currentFormId, this.vaultStateObject.vaultId).subscribe(
        (res) => {
          if (res) {
            let finalList = [];
            res.forEach((element, index) => {
              let tempEllemt = {
                ...element,
                name: '',
              };
              tempEllemt.name = element.form_name;
              finalList.push(tempEllemt);
            });
            this.entitiesItems = finalList;
            this.cd.detectChanges();
          }
        },
        (error: any) => {}
      )
    );
  }

  addVaultForm(item, index) {
    this.close.emit({
      isSuccess: true,
      item: item,
    });
  }
  clearSearchAction() {
    this.close.emit({
      isSuccess: true,
    });
    this.searchedStr = '';
    this.ngOnInit();
  }
}
